import { Box } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import ContactCard from '../Components/Contactcard'
import Aos from 'aos'
import "aos/dist/aos.css"
const Contact = () => {
  
  useEffect(() => {
    Aos.init({duration:500})
   
  }, [])
  return (
    <div >
<h1 style={{textAlign:"center",fontSize:"50px",marginTop:"40px",marginBottom:"30px"}}>
Get in Touch
</h1>
  <div>

    <div id="contact" display={"flex"} alignItems={"center"} height={"auto"}>
      
      <div display={"flex"} justifyContent={"center"}  height={"100%"} margin={"auto"}>
        <ContactCard   />
      </div>
      
      
      </div>
    </div>
    </div>
  )
}

export default Contact